import axios from "axios";
import Api from "@/resource/Api"


const state = {
    authenticated: false,
    groupEmail: "",
    accessToken: "",
    groupId: "",
    OTPCode: "",
    profilePic: "",
    deviceId: "",
    mainGroupId: "",
    uniqueID: "",
    groupCensusId: "",
    subGroupData:[],
    loginOtpSource: null // 'login' or 'forgot'

}

const getters = {
    deviceId: state => state.deviceId,
    groupEmail: state => state.groupEmail,
    authenticated: state => state.authenticated,
    accessToken: state => state.accessToken,
    OTPCode: state => state.OTPCode,
    mainGroupId: state => state.mainGroupId,
    groupId: state => state.groupId,
    uniqueID: state => state.uniqueID,
    groupCensusId: state => state.groupCensusId,
    getsubGroupData: state => state.subGroupData,
    loginOtpSource: state => state.loginOtpSource
}

const actions = {
       async getSubAccount({ commit, state }) {
            let mainGroupId = state.mainGroupId
            let url = 'sub-group/list?main_group='+mainGroupId
            Api.get(url)
              .then((res) => {
                commit('setsubGroupData',res.data.data)
              })
              .catch((err) => {
                commit('setsubGroupData',[])
                console.log("something went wrong!");
              });
          },
}

const mutations = {
    setAuthentication(state, status) {
        state.authenticated = status;
    },
    setGroupEmail(state, email) {
        state.groupEmail = email;
    },
    setLoginOtpSource(state, source) {
        state.loginOtpSource = source;
    },
    setAccessToken(state, token) {
        state.accessToken = token;
        axios.defaults.headers["Authorization"] =
            token != "" ? "Bearer " + token : "";
    },
    setGroupId(state, groupId) {
        state.groupId = groupId;
    },
    setOtpCode(state, otpCode) {
        state.OTPCode = otpCode;
    },
    setProfilePic(state, profilePic) {
        state.profilePic = profilePic;
    },
    setDeviceId(state, deviceId) {
        state.deviceId = deviceId;
    },
    setUniqueID(state, uniqueID) {
        state.uniqueID = uniqueID;
    },
    setMainGroupId(state, mainGroupId) {
        state.mainGroupId = mainGroupId;
    },
    setGroupCensusId(state, groupCensusId) {
        state.groupCensusId = groupCensusId
    },
    setsubGroupData(state, data){
        state.subGroupData = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
